import { EngagementPlan, RecurringTasksListView, TaskSummaryType } from '@redux/tasks/tasksTypes';
import { FREQUENCY_SELECT_OPTIONS } from 'components/FrequencySelectBlock/FrequencySelectBlock';

export interface GroupedTask {
  parent: TaskSummaryType;
  children: RecurringTasksListView[];
}

export const groupTasks = (tasks: TaskSummaryType[]): GroupedTask[] => {
  return tasks.map((task) => ({
    parent: task,
    children: task.recurringTasksList || []
  }));
};

export const countEngagementPlanTasks = (plan?: EngagementPlan | null): { recurring: number; noRepeat: number; total: number } => {
  const result = { recurring: 0, noRepeat: 0, total: 0 };

  if (!plan?.tasks?.length) {
    return result;
  }

  plan.tasks.forEach((task) => {
    if (task.frequencyType === FREQUENCY_SELECT_OPTIONS.every_day) {
      result.recurring += 1;
    } else {
      result.noRepeat += 1;
    }
  });

  return { ...result, total: result.recurring * plan.durationDays + result.noRepeat };
};
